import type { MrpInventoryRow } from "../../lib/mrp";

import { KITTING_EMPTY_SUBLOCATION_STOP } from "../manufacturing/kittingPickModel";
import type { KittingPickInventorySelection } from "../manufacturing/kittingPickInventorySelection";

function normalizeInventoryLocationCode(code: string): string {
  return code.trim().toLowerCase();
}

function uniqueSortedLocations(labels: Iterable<string>): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of labels) {
    const trimmed = raw.trim();
    if (trimmed.length === 0) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out.sort((left, right) => left.localeCompare(right, undefined, { sensitivity: "base" }));
}

export function isSkuDetailSgsInventoryRow(row: MrpInventoryRow): boolean {
  return normalizeInventoryLocationCode(row.location_code) === "sgs";
}

/** SGS floor bins for the SKU inventory location-change modal (hub sublocations, not CM sites). */
export function skuDetailSgsLocationChangeSelection(
  sku: string,
  rows: MrpInventoryRow[],
): {
  selection: KittingPickInventorySelection;
  knownStorageLocations: string[];
} {
  const sgsRow = rows.find(isSkuDetailSgsInventoryRow);
  const bins = (sgsRow?.sublocation_quantities ?? []).map((entry) => entry.sublocation.trim());
  const snapshot =
    sgsRow?.sublocation != null && String(sgsRow.sublocation).trim() !== ""
      ? String(sgsRow.sublocation).trim()
      : "";
  const knownStorageLocations = uniqueSortedLocations([
    KITTING_EMPTY_SUBLOCATION_STOP,
    ...bins,
    snapshot,
  ]);

  let storageLocation = KITTING_EMPTY_SUBLOCATION_STOP;
  const assignedBins = bins.filter(
    (label) => label.toLowerCase() !== KITTING_EMPTY_SUBLOCATION_STOP.toLowerCase(),
  );
  if (assignedBins.length === 1) {
    storageLocation = assignedBins[0];
  } else if (snapshot.length > 0) {
    storageLocation = snapshot;
  } else if (assignedBins.length > 1) {
    storageLocation = assignedBins[0];
  }

  return {
    selection: { sku: sku.trim(), storageLocation },
    knownStorageLocations,
  };
}
